export default {
  scene: {
    background: 0xffbc8d,
    fog: {
      color: 0xffbc8d,
      near: 50,
      far: 500
    }
  },
  camera: {
    position: {
      x: 9,
      y: 36,
      z: 112
    },
    focus: {
      from: {
        x: 0,
        y: 200,
        z: 0
      },
      to: {
        x: 0,
        y: 0,
        z: 0
      }
    }
  },
  leaves: {
    width: 300,
    height: 80,
    depth: 200,
    position: {
      x: 0,
      y: 40,
      z: 0
    },
    wind: {
      speed: 15,
      rotation: 0
    },
    count: 50,
    colors: [
      0xff7a7a,
      0xfeabab
    ]
  },
  road: {
    points: [
      [-200, 220],
      [-10, 70],
      [20, -10],
      [70, -40],
      [200, -50],
      [500, -60]
    ],
    width: 20,
    rotation: Math.PI / 2,
    color: 0xff8a68,
    pattern: require('@/assets/textures/pattern_b.png')
  },
  trees: [
    {
      path: '/models/objects/tree.glb',
      timeScale: 0.7,
      rotation: -Math.PI * 0.4,
      position: {
        x: -30,
        y: -0.1,
        z: 55
      }
    },
    {
      path: '/models/objects/tree.glb',
      timeScale: 0.6,
      rotation: -Math.PI * 0.4,
      position: {
        x: -20,
        y: -0.1,
        z: 0
      }
    },
    {
      path: '/models/objects/tree.glb',
      timeScale: 0.9,
      rotation: -Math.PI * 0.4,
      position: {
        x: 40,
        y: -0.1,
        z: 15
      }
    }
  ]
}
